import React from 'react';
import ModelContext from '../contexts/ModelContext.js';
import useIndex from '../hooks/use-index.js';
import { observer } from 'mobx-react';
import useCollection from './hooks/use-collection.js';

function CollectionEntryToModel(props) {
  var collection = useCollection();
  var index = useIndex();

  if (!collection || !collection[index]) {
    return null;
  }

  return /*#__PURE__*/React.createElement(ModelContext.Provider, {
    value: collection[index]
  }, props.children);
}

var CollectionEntryToModel$1 = observer(CollectionEntryToModel);

export default CollectionEntryToModel$1;
//# sourceMappingURL=CollectionEntryToModel.js.map
